export default "__VITE_ASSET__CbxsBmeE__"